import _ from 'lodash';

// Ensure these values are set correctly
const meetsStandardizationCriteria = (anAddress) => anAddress.country === 'US';

const isStdSvcAvailable = (anAddress) => {
    return anAddress
        && (anAddress.mustStandardize_Ext === true || anAddress.mustStandardize_Ext === undefined)
        && meetsStandardizationCriteria(anAddress);
};

const isStdBtnAvailable = (anAddress) => {
    return isStdSvcAvailable(anAddress)
        && ((_.isNil(anAddress.isNotValidated_Ext) || anAddress.isNotValidated_Ext === true)
        && !(anAddress.isValidated_Ext === true || anAddress.isOverridden_Ext === true));
};

const showStatus = (anAddress) => {
    return anAddress && (anAddress.mustStandardize_Ext === true || anAddress.mustStandardize_Ext === undefined)
        && anAddress.country === 'US'
        && (anAddress.isValidated_Ext === true || anAddress.isOverridden_Ext === true
        || (_.isNil(anAddress.isNotValidated_Ext) || anAddress.isNotValidated_Ext === true));
};

export default {
        'meetsStandardizationCriteria': meetsStandardizationCriteria,
        'isStdSvcAvailable': isStdSvcAvailable,
        'isStdBtnAvailable': isStdBtnAvailable,
        'showStatus': showStatus
}